/* Benhalex product gallery: a vertical thumbnail selector with wrap-around arrows.
 *
 * HISTORY, so nobody rebuilds a dead end. Two other shapes were tried on 2026-09-05 and rejected
 * by Omar: a 3D card stack (dropped before building, because 61.4% of this catalogue has two
 * images or fewer and it would have degraded to a single card with a "01 / 01" counter), and a
 * large auto-scrolling strip with a cloned track ("I dont like it"). This is the third and the
 * one that stayed: a plain selector, made good by its states rather than by motion.
 *
 * WHAT THIS ADDS OVER DAWN. Dawn's <media-gallery> already switches the main image when a
 * thumbnail is pressed, accessibly, and it stays in charge of that. This adds only:
 *
 *   1. Up/down arrows that CYCLE. Dawn's own controls stop dead at each end; Omar asked for the
 *      last photo to step back to the first.
 *   2. Keeping the active thumbnail scrolled into view in a vertical rail.
 *   3. A single-image state. 24.8% of products have no image and 30.9% have exactly one, measured
 *      across all 6,388 on 2026-09-05, so one image is the common case. Those get a plain picture
 *      with no rail and no chrome at all.
 *
 * The arrows work by clicking the real thumbnail button, so every route through the gallery goes
 * through Dawn's code and there is never a second opinion about which slide is showing.
 */
(function () {
  "use strict";

  function thumbsOf(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll(".thumbnail-list__item .thumbnail"));
  }

  function activeIndex(thumbs) {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].getAttribute("aria-current") === "true") return i;
    }
    return 0;
  }

  function makeArrow(dir, label) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "bhx-gallery__arrow bhx-gallery__arrow--" + dir;
    b.setAttribute("aria-label", label);
    // Inline SVG rather than a glyph, so it inherits currentColor and never waits on a font.
    b.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
      'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      (dir === "up" ? '<path d="M18 15l-6-6-6 6"/>' : '<path d="M6 9l6 6 6-6"/>') +
      "</svg>";
    return b;
  }

  function init(gallery) {
    if (gallery.dataset.bhxGallery === "1") return;
    gallery.dataset.bhxGallery = "1";
    gallery.classList.add("bhx-gallery");

    var thumbs = thumbsOf(gallery);
    if (thumbs.length < 2) {
      gallery.classList.add("bhx-gallery--single");
      return;
    }

    var rail = gallery.querySelector(".thumbnail-slider");
    var list = gallery.querySelector(".thumbnail-list");

    function keepInView(btn) {
      if (!list || !btn) return;
      var item = btn.closest(".thumbnail-list__item") || btn;
      var lb = list.getBoundingClientRect();
      var ib = item.getBoundingClientRect();
      if (ib.top < lb.top) list.scrollTop -= lb.top - ib.top;
      else if (ib.bottom > lb.bottom) list.scrollTop += ib.bottom - lb.bottom;
    }

    function step(delta) {
      var current = thumbsOf(gallery);
      if (!current.length) return;
      // The modulo is the point: wrap rather than stop at either end.
      var next = (activeIndex(current) + delta + current.length) % current.length;
      current[next].click();
      keepInView(current[next]);
    }

    if (rail) {
      var up = makeArrow("up", "Previous image");
      var down = makeArrow("down", "Next image");
      up.addEventListener("click", function () { step(-1); });
      down.addEventListener("click", function () { step(1); });
      rail.insertBefore(up, rail.firstChild);
      rail.appendChild(down);
    }

    gallery.addEventListener("click", function (e) {
      var t = e.target.closest(".thumbnail");
      if (t) setTimeout(function () { keepInView(t); }, 0);
    });

    gallery.classList.add("bhx-gallery--rail");
  }

  function boot(root) {
    var nodes = (root || document).querySelectorAll("media-gallery");
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
